import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import { languages } from './languages';
import { KEY_LANGUAGE } from 'const';
import CORE_SETTINGS from 'settings';

const listLanguagesPrefix = CORE_SETTINGS.displayedLanguages
  .filter((lang) => lang !== CORE_SETTINGS.excludeLanguage)
  .join('|');

export const PATH_LANGUAGE_PREFIX = listLanguagesPrefix ? `/:lang(${listLanguagesPrefix})?` : '';

const cookieLng = Cookies.get(KEY_LANGUAGE);
const cookieLngI18n = Cookies.get('i18next');

i18n
  .use(backend)
  .use(languageDetector)
  .use(initReactI18next)
  .use(ICU)
  .init({
    ns: ['translations'],
    defaultNS: 'translations',
    fallbackLng: CORE_SETTINGS.defaultLanguage,
    react: {
      useSuspense: false
    },
    lng: cookieLng || cookieLngI18n || CORE_SETTINGS.defaultLanguage,
    resources: languages,
    detection: {
      caches: ['cookie']
    }
  }).then();
